//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'

export default {
  name: 'CIWAArScore',
  data () {
    return {
      form: {
        answer1: '',
        answer2: '',
        answer3: '',
        answer4: '',
        answer5: '',
        answer6: '',
        answer7: '',
        answer8: '',
        answer9: '',
        answer10: ''
      },
      hasScore: false,
      disabled: false,
      dataList1: [
        { value: '0', name: '无恶心及呕吐' },
        { value: '1', name: '轻度恶心但无呕吐' },
        { value: '2', name: '轻度恶心但无呕吐' },
        { value: '3', name: '轻度恶心但无呕吐' },
        { value: '4', name: '阵发性恶心伴干呕' },
        { value: '5', name: '阵发性恶心伴干呕' },
        { value: '6', name: '阵发性恶心伴干呕' },
        { value: '7', name: '持续性恶心、频繁干呕及呕吐' }
      ],
      dataList2: [
        { value: '0', name: '无震颤' },
        { value: '1', name: '不明显，但指尖可感受到' },
        { value: '2', name: '不明显，但指尖可感受到' },
        { value: '3', name: '不明显，但指尖可感受到' },
        { value: '4', name: '中度，患者手臂展开时震颤' },
        { value: '5', name: '中度，患者手臂展开时震颤' },
        { value: '6', name: '中度，患者手臂展开时震颤' },
        { value: '7', name: '重度，手臂不展开时也有震颤' }
      ],
      dataList3: [
        { value: '0', name: '无盗汗' },
        { value: '1', name: '出汗不明显、手掌湿' },
        { value: '2', name: '出汗不明显、手掌湿' },
        { value: '3', name: '出汗不明显、手掌湿' },
        { value: '4', name: '额头明显汗珠' },
        { value: '5', name: '额头明显汗珠' },
        { value: '6', name: '额头明显汗珠' },
        { value: '7', name: '大汗淋漓' }
      ],
      dataList4: [
        { value: '0', name: '不焦虑、轻松自在' },
        { value: '1', name: '轻度焦虑' },
        { value: '2', name: '轻度焦虑' },
        { value: '3', name: '轻度焦虑' },
        { value: '4', name: '中度焦虑、或存在防备心理' },
        { value: '5', name: '中度焦虑、或存在防备心理' },
        { value: '6', name: '中度焦虑、或存在防备心理' },
        {
          value: '7',
          name: '相当于严重谵妄中所见的急性恐慌状态，或急性精神分裂症反应'
        }
      ],
      dataList5: [
        { value: '0', name: '正常活动' },
        { value: '1', name: '比正常活动稍微亢奋' },
        { value: '2', name: '比正常活动稍微亢奋' },
        { value: '3', name: '比正常活动稍微亢奋' },
        { value: '4', name: '中度烦躁和坐立不安' },
        { value: '5', name: '中度烦躁和坐立不安' },
        { value: '6', name: '中度烦躁和坐立不安' },
        { value: '7', name: '访谈大部分时间踱来踱去或烦躁不安的走来走去' }
      ],
      dataList6: [
        { value: '0', name: '无异常' },
        { value: '1', name: '非常轻微瘙痒、针刺感、灼热或麻木' },
        { value: '2', name: '轻微瘙痒、针刺感、灼热或麻木' },
        { value: '3', name: '中度瘙痒、针刺感、灼热或麻木' },
        { value: '4', name: '中度严重幻觉 ' },
        { value: '5', name: '严重幻觉' },
        { value: '6', name: '非常严重的幻觉' },
        { value: '7', name: '持续性幻觉' }
      ],
      dataList7: [
        { value: '0', name: '不存在' },
        { value: '1', name: '非常轻微的刺耳声或受惊吓' },
        { value: '2', name: '轻微的刺耳声或受惊吓' },
        { value: '3', name: '中度的刺耳声或受惊吓 ' },
        { value: '4', name: '中度严重幻觉' },
        { value: '5', name: '严重幻觉' },
        { value: '6', name: '非常严重的幻觉' },
        { value: '7', name: '持续性幻觉' }
      ],
      dataList8: [
        { value: '0', name: '不存在' },
        { value: '1', name: '非常轻微的敏感度' },
        { value: '2', name: '轻微的敏感度' },
        { value: '3', name: '中度的敏感度' },
        { value: '4', name: '中度严重幻觉' },
        { value: '5', name: '严重幻觉' },
        { value: '6', name: '非常严重的幻觉' },
        { value: '7', name: '持续性幻觉' }
      ],
      dataList9: [
        { value: '0', name: '不存在 ' },
        { value: '1', name: '非常轻微' },
        { value: '2', name: '轻微' },
        { value: '3', name: '中度' },
        { value: '4', name: '中度严重' },
        { value: '5', name: '严重' },
        { value: '6', name: '很严重' },
        { value: '7', name: '非常严重' }
      ],
      dataList10: [
        { value: '0', name: '定位力好且可做系列加法' },
        { value: '1', name: '不能进行系列加法或不确定日期' },
        { value: '2', name: '日期定位出入不超过两个公历日' },
        { value: '3', name: '日期定位出入超过两个公历日' },
        { value: '4', name: '地点和/或人定位错误 ' }
      ],
      descTxt: ''
    }
  },
  created () {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad'])
  },
  computed: {
    /** 计算公式结果 */
    score () {
      let self = this
      let form = JSON.parse(JSON.stringify(self.form))
      let flag = true
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false
          } else {
            form[key] = Number(form[key])
          }
        }
      }
      if (!flag) {
        self.hasScore = false
        return ''
      } else {
        let result =
          form.healthcondition +
          form.stomachache +
          form.waterystool +
          form.abdominalmass +
          form.jointpain +
          form.uveitis +
          form.ENL +
          form.Aphitulcer +
          form.pyoderma +
          form.analfissure +
          form.Neonatalfistula +
          form.abscess
        if (result < 5) {
          self.descTxt = '临床缓解期 '
        } else if (result > 4 && result < 8) {
          self.descTxt = '轻度活动期'
        } else if (result > 7 && result < 17) {
          self.descTxt = '中度活动期 '
        } else if (result > 16) {
          self.descTxt = '重度活动期'
        }
        self.hasScore = true
        return String(result)
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/formulas/GIT/CIWAArScore.vue